<template>
  <v-card flat>
    <v-card-text class="pb-0">
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap>
          <!-- Rule Object Type -->
          <v-flex md2 sm2>
            <v-select v-model="selectedRuleCategory" :label="messages.label.RULE_CATEGORY" :items="ruleCategoryList"
              item-text="text" item-value="value" return-object></v-select>
          </v-flex>
          <!-- Rule Type -->
          <v-flex md2 sm2>
            <v-select v-model="selectedRuleType" :label="messages.label.TYPE" :items="ruleTypes" item-text="text"
              item-value="value" item-disabled="disable" return-object></v-select>
          </v-flex>
          <!-- Rule State -->
          <v-flex md1 sm1>
            <v-select v-model="selectedRuleState" :label="messages.label.RULE_STATE" :items="ruleStateList"
              item-text="text" item-value="value" return-object></v-select>
          </v-flex>
          <!-- Rule Title -->
          <v-flex md2 sm2>
            <v-text-field :label="messages.label.RULE_TITLE" v-model="ruleTitle" @keyup.enter="searchRules()" clearable>
            </v-text-field>
          </v-flex>
          <!-- Search Button -->
          <v-flex md2 sm2>
            <v-btn color="primary" @click="searchRules()">{{
                messages.label.SEARCH
            }}</v-btn>
          </v-flex>
          <v-flex md3 sm3 class="text-xs-right"> </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex"
import XVATRulesService from "@/XVAT/XVATRulesService"
import messages from "@/XVAT/messages.json"
import AppService from "@/AppService"
import {
  RULE_TYPE_VALIDATION,
  RULE_TYPE_TRANSFORMATION,
  RULE_CAT_RULE,
  RULE_CAT_RULE_SET,
  RULE_CAT_RULE_COLLECTION
} from "./constants"
import { GET_XPATH_MAPPINGS_LIST } from "@/store/constants/action-types"

/**
 * initialData
 */
function initialData(instance) {
  return {
    selectedRuleCategory: { text: messages.label.RULE, value: RULE_CAT_RULE },
    ruleCategoryList: instance.getRuleCategories(),
    ruleTypes: instance.getRuleTypes(),
    ruleStateList: instance.getRuleStates(),
    selectedRuleType: { text: messages.label.ALL, value: "all" },
    selectedRuleState: { text: messages.label.ALL, value: "all" },
    ruleTitle: ""
  }
}

export default {
  name: "XVATRulesSearchFilter",
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState("xvat", ["xpathMappingsList"])
  },
  watch: {
  },
  methods: {
    ...mapActions("xvat", [GET_XPATH_MAPPINGS_LIST]),

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * getRuleGroupings
     * @returns {array}
     */
    getRuleCategories() {
      return [
        { text: messages.label.RULE, value: RULE_CAT_RULE },
        { text: messages.label.RULE_SET, value: RULE_CAT_RULE_SET },
        { text: messages.label.RULE_COLLECTION, value: RULE_CAT_RULE_COLLECTION }
      ]
    },

    /**
     * getRuleTypes
     * @returns {array}
     */
    getRuleTypes() {
      return [
        { text: messages.label.ALL, value: "all", disable: false },
        { text: RULE_TYPE_VALIDATION, value: RULE_TYPE_VALIDATION, disable: false },
        { text: RULE_TYPE_TRANSFORMATION, value: RULE_TYPE_TRANSFORMATION, disable: false }
      ]
    },

    /**
     * getRuleStates
     * @returns {array}
     */
    getRuleStates() {
      return [
        { text: messages.label.ALL, value: "all" },
        { text: messages.label.ENABLED, value: "enabled" },
        { text: messages.label.DISABLED, value: "disabled" }
      ]
    },
    /**
     * searchRules - trigger the search event for retrieving all the rules, rule sets and rule collection
     */
    searchRules() {
      let searchParams = {
        category: this.selectedRuleCategory.value
      }
      // Disabled query
      if (this.selectedRuleState.value === "enabled") {
        searchParams.byDisabled = false
      } else if (this.selectedRuleState.value === "disabled") {
        searchParams.byDisabled = true
      }
      // Title Query
      if (this.ruleTitle && this.ruleTitle !== "") {
        searchParams.byTitlePrefix = this.ruleTitle
      } else {
        searchParams.byTitlePrefix = ""
      }
      // Type Query
      if (this.selectedRuleType.value !== "all") {
        searchParams.byType = this.selectedRuleType.value
      }

      XVATRulesService.$emit("event:searchMetadataRules", searchParams)
    },

   /**
    * retrieveXPathMappings - Retreive mappings to display field dropdown
    */
    retrieveXPathMappings() {
      // Update store with xpath mappings
      if (this.xpathMappingsList.length === 0) {
        // this.loadingXpathMappings = true
        this.GET_XPATH_MAPPINGS_LIST()
          .catch(() => {
            // TODO: handle error
          }).finally(() => {
            // this.loadingXpathMappings = false
          })
      } else {
        return Promise.resolve(this.xpathMappingsList)
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
    * Initial data
    */
    this.retrieveXPathMappings()
    /**
     * Events
     */
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/XVAT/XVATRulesSearchFilter.vue